import React from 'react'
import Drawer from '@mui/material/Drawer';
import List from './List';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import Symbol from './Symbol';
export default function DrawerLeft(props) {
    return (
        <div>
            <React.Fragment>
            <Drawer
                anchor="left"
                open={props.IsOpen}
                onClose={()=>{props.onClose()}}
                
            >
                <div className="drawer">
                    <div className="text searchContainer">
                        <input type="text" placeholder="search places" onChange={(event)=>{
                            props.searchPlace(event);
                            
                        }}>
                            
                        </input>

                        <div className="searchButton flexCenter"><p>Search</p></div>
                    </div>
                    {props.places.length===0? <Symbol name={()=>{
                        return <SearchOffOutlinedIcon/>
                    }}/>:null}
                    <List places={props.places} selectPlace={props.selectPlace} closeDrawer={props.onClose}></List>
                </div>
            </Drawer>
        </React.Fragment>
        </div>
    )
}
